import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

const RegisterPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const { register, checkUserStatus } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    try {
      await register(email, password, name);
      navigate('/welcome');
    } catch (err: any) {
      console.error('🔥 Registration error in RegisterPage:', err);
      console.error('🔥 Error message:', err.message);
      console.error('🔥 Full error object:', err);
      
      // If it's a "user already registered" error, check the user status and provide better guidance
      if (err.message.includes('User already registered') || err.message.includes('already exists')) {
        console.log('📋 Handling "User already registered" scenario');
        try {
          const userStatus = await checkUserStatus(email);
          console.log('📊 User status from check:', userStatus);
          
          if (userStatus.exists) {
            console.log('✅ User exists - directing to login');
            setError('An account with this email already exists. Please try logging in instead.');
          } else {
            console.log('❌ User does not exist - showing unconfirmed message');
            setError('This email is associated with an unconfirmed account. Please check your email (including spam folder) for a confirmation link. If you can\'t find it, try logging in or use a different email address.');
          }
        } catch (statusError) {
          console.error('🔥 Error checking user status:', statusError);
          setError('An account with this email may already exist. Please try logging in instead, or use a different email address.');
        }
      } else {
        console.log('📋 Showing original error message');
        setError(err.message || 'Registration failed. Please try again.');
      }
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Create Account</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="auth-button">
            Sign Up
          </button>
        </form>
        <p className="auth-link">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;